export const ActivityTagHotSceneEnum = {
  SKIN_HOT_SEARCH: { id: 1, name: "热搜" },
  SKIN_SEARCH_RECOMMEND: { id: 2, name: "搜索推荐" }
}

export const ActivityTagGroupSceneEnum = {
  SKIN_TAG: { id: 1, name: '模板标签' }
}

export const ActivityTagGroupEnum = {
  SKIN_USE: { id: 1000, name: '模板用途' },
  SKIN_TYPE: { id: 1001, name: '模板类型' },
  SKIN_FESTIVAL: { id: 1002, name: '节日节点' }
}
